import { CommonModule } from "@angular/common";
import { provideTranslocoScope } from "@jsverse/transloco";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { SharedModule } from "@app/shared/shared.module";
import { AssetManagementOverviewComponent } from "./pages/assetmanagement-overview/assetmanagement-overview.component";
import { AssetManagementService } from "./services/assetmanagement-data.service";
import { ThirdPartyDataService } from "@pages/thirdparty/services/ThirdPartyDataService";
import { ThirdPartyContractDataService } from "@pages/thirdparty/services/ThirdPartyContractDataService";

@NgModule({
    imports: [CommonModule, SharedModule.forRoot()],
    declarations: [AssetManagementOverviewComponent],
    providers: [provideTranslocoScope("assetmanagement")],
})
export class AssetManagementModule {
    static forRoot(): ModuleWithProviders<AssetManagementModule> {
        return {
            ngModule: AssetManagementModule,
            providers: [AssetManagementService, ThirdPartyDataService, ThirdPartyContractDataService],
        };
    }
}
